import { VesselPartTypeEnum } from "open-vessel-definition";

export const PARTS_COLORS = {
  [VesselPartTypeEnum.BAY]: "--sl-color-gray-400",
  [VesselPartTypeEnum.BRIDGE]: "--sl-color-violet-600",
  [VesselPartTypeEnum.CRANE]: "--sl-color-orange-700",
  [VesselPartTypeEnum.SMOKE]: "--sl-color-green-500",
  [VesselPartTypeEnum.SPACER]: "--sl-color-amber-300",
};
